export enum CreatorNetworkMessageType {
  PlayableScenario = 0,
  ReadyForScenario = 1,
  StartPlayingScenario = 2,
  FinishPlayingScenario = 3,
  AbortScenario = 4,
  CreatorConnected = 5,
  UnityConnected = 6,
  SyncEnvironment = 7,
  SyncProp = 8,
  SyncSituation = 9,
  SyncEnvironmentProps = 10,
}

export interface CreatorNetworkMessage {
  messageType: CreatorNetworkMessageType;
  data: string;
}
